var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Modal from "../../UI/Modal/Modal";
import useService from "../../Hooks/useService";
import AdvisorService from "../../../Services/Advisor.service";
import ModalHeader from "../../UI/Modal/ModalHeader";
import ValidationService from "../../../Services/Shared/Validation.service";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import { CancelButton, SaveButton, } from "../../UI/StandardButtons/StandardButtons";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
const EditAdvisorModal = (_a) => {
    var { termToRepresentAdvisor, currentAdvisor, studentAffiliationId, onEdit } = _a, modalProps = __rest(_a, ["termToRepresentAdvisor", "currentAdvisor", "studentAffiliationId", "onEdit"]);
    const { errors, control, handleSubmit } = useForm({
        // @ts-expect-error - TS2322 - Type 'PersonLite | null | undefined' is not assignable to type 'DeepPartial<PersonLite> | undefined'.
        defaultValues: { advisor: currentAdvisor },
    });
    const [assignAdvisorState, assignAdvisor] = useService(AdvisorService.assignAdvisor);
    const submit = (state) => {
        // assign advisor
        assignAdvisor(studentAffiliationId, state.advisor.affiliationId).then(() => {
            modalProps.onModalClosed();
            onEdit(state.advisor);
        });
    };
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: `Edit ${termToRepresentAdvisor}`, closeModal: modalProps.onModalClosed }), modalProps.isOpen && (_jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { children: termToRepresentAdvisor }), _jsx(Controller, { as: _jsx(DeprecatedSelect.Async, { loadOptions: (query) => AdvisorService.search(query).then((options) => ({
                                                options,
                                            })), clearable: false, valueKey: "personId", labelKey: "fullName", placeholder: "Unassigned", className: ValidationService.makeClassName(errors, "advisor") }), control: control, name: "advisor", rules: {
                                            // @ts-expect-error - TS7006 - Parameter 'advisor' implicitly has an 'any' type.
                                            validate: (advisor) => currentAdvisor &&
                                                currentAdvisor.personId !== advisor.personId,
                                        } }), _jsxs("div", { className: "invalid-feedback", children: ["Please pick a different ", termToRepresentAdvisor] })] }), assignAdvisorState.hasError && (_jsx(AlertError, { message: "There was an error assigning this advisor", detail: assignAdvisorState.errorMessage }))] }), _jsxs("div", { className: "modal-footer", children: [_jsx(SaveButton, { type: "submit", isLoading: assignAdvisorState.isLoading }), _jsx(CancelButton, { onClick: () => modalProps.onModalClosed() })] })] }))] })));
};
export default EditAdvisorModal;
